'use client'

import { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import {
    FaTelegramPlane,
    FaVk,
    FaEnvelope,
    FaPhoneAlt,
    FaWhatsapp,
} from 'react-icons/fa'

import SubscribeForm from './SubscribeForm'
import Container from '@/app/(public-pages)/catalog/components/CatalogContainer'
import Button from '../ui/Button'
import CallbackModal from '@/app/components/CallbackModal'

const Footer = () => {
    const [open, setOpen] = useState(false)
    return (
        <footer className="bg-primary text-gray-300">
            <Container>
                <div className="mx-auto max-w-7xl border-b border-white/10 py-10 px-10 xl:px-2 lg:py-14 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
                    <div className="space-y-5">
                        <div className="flex gap-3 items-center">
                            <Image
                                src="/image/logo/logo-white.png"
                                width={250}
                                height={150}
                                alt="logo"
                            />
                            {/* <p className="text-2xl font-bold text-white tracking-tight">
                                МаркетСИЗ
                            </p> */}
                        </div>

                        <div className="text-sm flex flex-col gap-4">
                            <a
                                href="tel:+79162015339"
                                className="flex items-center gap-2 text-base font-semibold text-white hover:text-white/80 transition-colors hover:underline"
                            >
                                <FaPhoneAlt size={20} />
                                +7 916 201 53 39
                            </a>
                            <a
                                href="tel:+79162015339"
                                className="flex items-center gap-2 text-base font-semibold text-white hover:text-white/80 transition-colors hover:underline"
                            >
                                <FaWhatsapp size={20} />
                                +7 916 201 53 39
                            </a>

                            <a
                                href="mailto:snab@marketsiz.ru"
                                className="flex items-center gap-2 text-base font-semibold text-white hover:text-white/80 transition-colors hover:underline"
                            >
                                <FaEnvelope size={20} />
                                snab@marketsiz.ru
                            </a>

                            <Button
                                onClick={() => setOpen(true)}
                                className="border-none inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-second px-4 font-semibold text-white transform hover:scale-105 transition-all duration-300"
                            >
                                Заказать звонок
                            </Button>

                            <CallbackModal
                                isOpen={open}
                                onClose={() => setOpen(false)}
                            />
                            {/* <div className="flex items-center gap-3 text-xl">
                                <Link
                                    href="#"
                                    className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white hover:bg-white/10 transition-colors"
                                >
                                    <FaTelegramPlane size={20} />
                                </Link>
                                <Link
                                    href="#"
                                    className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white hover:bg-white/10 transition-colors"
                                >
                                    <FaVk size={20} />
                                </Link>
                                <Link
                                    href="#"
                                    className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white hover:bg-white/10 transition-colors"
                                >
                                    <FaEnvelope size={20} />
                                </Link>
                            </div> */}
                        </div>
                    </div>

                    <div>
                        <div className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-4">
                            Покупателям
                        </div>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>
                                <Link
                                    href="/contacts"
                                    className="hover:text-white transition-colors"
                                >
                                    Контакты
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="/logotip-na-zakaz"
                                    className="hover:text-white transition-colors"
                                >
                                    Нанесение логотипов
                                </Link>
                            </li>
                            {/* <li>
                                <Link
                                    href="#"
                                    className="hover:text-white transition-colors"
                                >
                                    Новости и статьи
                                </Link>
                            </li> */}
                        </ul>
                    </div>

                    <div>
                        <div className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-4">
                            Где купить?
                        </div>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>
                                <Link
                                    href="/delivery"
                                    className="hover:text-white transition-colors"
                                >
                                    Доставка и оплата
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="/size-guide"
                                    className="hover:text-white transition-colors"
                                >
                                    Таблица размеров
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="/pricelist"
                                    className="hover:text-white transition-colors"
                                >
                                    Скачать каталог
                                </Link>
                            </li>
                            {/* <li>
                                <Link
                                    href="#"
                                    className="hover:text-white transition-colors"
                                >
                                    Материалы и технологии
                                </Link>
                            </li> */}
                        </ul>
                    </div>

                    {/* ПОДПИСКА + CTA */}
                    <div className="flex flex-col gap-4">
                        <div>
                            <div className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-3">
                                Подписаться на новости
                            </div>
                            <SubscribeForm />
                        </div>
                    </div>
                </div>

                <div className="mx-auto max-w-7xl flex flex-col items-center justify-between gap-3 py-6 text-xs text-gray-500 sm:flex-row">
                    <p className="text-center sm:text-left">
                        Политика обработки персональных данных · Правила продажи
                        · Правила применения рекомендательных технологий
                    </p>
                    <p>© {new Date().getFullYear()} Все права защищены</p>
                </div>
            </Container>
        </footer>
    )
}

export default Footer
